import React, { useEffect } from "react";
import Header from "../../../Components/Header/Header";
import { Card, Typography } from "antd";
import ValidationTable from "./ValidationTable/ValidationTable";
import { useValidateCrfa } from "./hooks/useValidateCrfa";
import Spinner from "../../../Components/Spinner";

const { Text } = Typography;

const AudbilityValidateCrfa = () => {
  const { pendingCrfaList, isLoading, getPendingCrfa, lastUserSub } =
    useValidateCrfa();

  useEffect(() => {
    getPendingCrfa();
  }, []);

  return (
    <Card bordered={false} bodyStyle={{ padding: 0 }}>
      <Header text="Validar CRFa" style={{ marginBottom: "20px" }} />
      {isLoading ? (
        <Spinner />
      ) : pendingCrfaList?.length > 0 ? (
        <ValidationTable
          listDocuments={pendingCrfaList}
          getPendingCrfa={getPendingCrfa}
          lastUserSub={lastUserSub}
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Text>Nenhum documento pendente de validação</Text>
        </div>
      )}
    </Card>
  );
};

export default AudbilityValidateCrfa;
